import type { CallAction, CallState } from './types';


export const initialCallState: CallState = {
  phase: 'idle',
  callId: null,
  peerId: null,
  peerName: null,
  peerAvatarUrl: null,
  callType: null,
  direction: null,
  error: null,
  endedReason: null,
  muted: false,
  cameraOff: false,
  remoteSignal: null,
  connectedAt: null,
};


const mismatchedCall = (state: CallState, callId: string): boolean =>
  state.callId !== null && state.callId !== callId;


export function callReducer(state: CallState, action: CallAction): CallState {
  if (action.type === 'RESET' || action.type === 'LOGOUT') return initialCallState;
  if (state.phase === 'ended') return state;

  switch (action.type) {
    case 'START_PREPARING':
      return {
        ...initialCallState,
        phase: 'preparing',
        peerId: action.peerId,
        peerName: action.peerName ?? null,
        peerAvatarUrl: action.peerAvatarUrl ?? null,
        callType: action.callType,
        direction: 'outgoing',
      };
    case 'SERVER_RINGING':
      return {
        ...state,
        phase: 'ringing',
        callId: action.callId,
        peerId: action.peerId,
        callType: action.callType,
        direction: 'outgoing',
        error: null,
      };
    case 'SERVER_INCOMING':
      if (state.phase !== 'idle') return state;
      return {
        ...initialCallState,
        phase: 'incoming',
        callId: action.callId,
        peerId: action.peerId,
        callType: action.callType,
        direction: 'incoming',
      };
    case 'LOCAL_ACCEPTED':
      if (mismatchedCall(state, action.callId)) return state;
      return { ...state, phase: 'connecting' };
    case 'SERVER_ACCEPTED':
      if (mismatchedCall(state, action.callId)) return state;
      return { ...state, phase: 'connecting', callId: action.callId, callType: action.callType };
    case 'PEER_CONNECTED':
      if (mismatchedCall(state, action.callId)) return state;
      return { ...state, phase: 'active', connectedAt: action.connectedAt };
    case 'SERVER_SIGNAL':
      if (mismatchedCall(state, action.signal.callId)) return state;
      return { ...state, remoteSignal: action.signal };
    case 'SERVER_ENDED':
      if (mismatchedCall(state, action.callId)) return state;
      return { ...state, phase: 'ended', callId: action.callId, endedReason: action.reason };
    case 'SERVER_ERROR':
      return { ...state, phase: 'ended', error: action.code };
    case 'SET_MUTED':
      return { ...state, muted: action.value };
    case 'SET_CAMERA_OFF':
      return { ...state, cameraOff: action.value };
  }
}
